import React from 'react';

/**
 * Live chat is now powered by the Chatwoot Website SDK, loaded globally in
 * index.html (Chatwoot renders its own bubble). This placeholder component is
 * kept as a no-op so existing page imports continue to work without rendering a
 * duplicate chat bubble.
 */
export default function FloatingChat() {
  return null;
}